<template>
    <div>
        <div style="width: 84%;margin-left: 7%;margin-top: 20%" v-html="content">
        </div>
    </div>
</template>

<script>

export default {
    name: "StoreClosed",
    computed: {
        content() {
            const country = this.$route.params.countryPath
            if (country == 'KR') {
                return `<p class=" SecondTitle multiline-text">
            ${this.$t("storeClosed.title")}
            </p>
            <p class="SecondTitle multiline-text">
                ${this.$t("storeClosed.tips")}
            </p>`
            } else {
                return `<p class=" SecondTitle multiline-text">
            ${'Page not using'}
            </p>`
            }
        },
    }
}
</script>
<style>
.multiline-text {
    white-space: pre-line;
}
</style>